import { createContext } from "react";
export const ListContext = createContext({
    listType: "ul",
    size: "medium",
});
//# sourceMappingURL=List.context.js.map